// Score keeper for the game pages. One script, one config per game, picked by #calc[data-game] (default: Hand and Foot).
// Two teams, house values editable, saved on this device. Canasta has two rule sets (classic, Modern American) behind the .modes buttons.
// Pinochle is a plain config: bid, meld and trick points only, with its own status line and result.
(function () {
  var calc = document.getElementById('calc'); if (!calc) return;
  var each = function (k) { return function (h) { return h[k].toLocaleString() + ' each'; }; };
  var times = function (k) { return function (v, h) { return v * h[k]; }; };
  var num = function (o, k) { return Number(o[k]) || 0; };
  var THREES = [0, 100, 300, 500, 1000]; // Modern American: per colour, by how many a team laid down
  var GAMES = {
    // Four fixed rounds; the first meld rises by round.
    hf: {
      key: 'lotus-hf-v1', rounds: 4, mins: [50, 90, 120, 150], leftLabel: 'Cards left in hand and foot',
      house: { clean: 500, dirty: 300, wild: 1500, out: 100, red: 100, redCaught: 100 },
      houseLabels: { clean: 'Clean book', dirty: 'Dirty book', wild: 'Wild book', out: 'Going out', red: 'Red three laid down', redCaught: 'Red three caught (minus)' },
      lines: [
        { k: 'clean', label: 'Clean books', note: each('clean'), pts: times('clean') },
        { k: 'dirty', label: 'Dirty books', note: each('dirty'), pts: times('dirty') },
        { k: 'wild', label: 'Wild books', note: each('wild'), pts: times('wild') },
        { k: 'red', label: 'Red threes laid down', note: each('red'), pts: times('red') },
        { k: 'redCaught', label: 'Red threes caught in hand', note: function (h) { return 'minus ' + h.redCaught + ' each'; }, pts: function (v, h) { return -v * h.redCaught; } }
      ]
    },
    // Classic canasta: hands until a team reaches 5,000; the first meld depends on each team's running total.
    canasta: {
      key: 'lotus-canasta-v1', rounds: 0, target: 5000, leftLabel: 'Cards left in hand',
      need: function (total) { return total < 0 ? 15 : total < 1500 ? 50 : total < 3000 ? 90 : 120; },
      house: { natural: 500, mixed: 300, out: 100, concealed: 100, red: 100 },
      houseLabels: { natural: 'Natural canasta', mixed: 'Mixed canasta', out: 'Going out', concealed: 'Concealed, extra', red: 'Red three' },
      concealed: true,
      lines: [
        { k: 'natural', label: 'Natural canastas', note: each('natural') },
        { k: 'mixed', label: 'Mixed canastas', note: each('mixed') },
        { k: 'red', label: 'Red threes', max: 4, note: function (h) { return h.red + ' each, all four ' + (h.red * 8).toLocaleString() + '. Counted against a team with no meld'; } }
      ],
      // Red threes turn against a team that melded nothing (no canastas and no melded card points).
      score: function (v, h) {
        var red = (v.red >= 4 ? 2 : 1) * v.red * h.red, melded = v.natural || v.mixed || v.melded;
        return v.natural * h.natural + v.mixed * h.mixed + (melded ? red : -red) + v.melded - v.left;
      }
    },
    // Modern American canasta: 8,500; threes and melded cards swing on how many canastas the team closed.
    canastaMA: {
      key: 'lotus-canasta-ma-v1', rounds: 0, target: 8500, leftLabel: 'Cards left in hand',
      need: function (total) { return total < 3000 ? 125 : total < 5000 ? 155 : 180; },
      house: { mixed: 300, pure: 500, special: 2500, wild: 2000, out: 100 },
      houseLabels: { mixed: 'Mixed canasta', pure: 'Pure canasta', special: 'Pure sevens or aces', wild: 'Wild canasta', out: 'Going out' },
      lines: [
        { k: 'mixed', label: 'Mixed canastas', note: each('mixed') },
        { k: 'pure', label: 'Pure canastas', note: each('pure') },
        { k: 'special', label: 'Pure canastas of sevens or aces', note: each('special') },
        { k: 'wild', label: 'Wild canastas', note: function (h) { return h.wild.toLocaleString() + ' each. Four jokers or seven twos score more: add the rest under Other bonuses'; } },
        { k: 'red', label: 'Red threes', max: 4, note: function () { return '100, 300, 500 or 1,000. Added with two canastas, nothing with one, subtracted with none'; } },
        { k: 'black', label: 'Black threes', max: 4, note: function () { return 'scored the same way as red threes'; } },
        { k: 'pen', label: 'Penalties', step: 500, note: function () { return 'unfinished sevens, aces or wild melds; three sevens or aces in a hand'; } },
        { k: 'bonus', label: 'Other bonuses', step: 500, note: function () { return 'special hands, and the extra for a jokers or twos canasta'; } }
      ],
      score: function (v, h) {
        var c = v.mixed + v.pure + v.special + v.wild, threes = THREES[Math.min(4, v.red)] + THREES[Math.min(4, v.black)];
        return v.mixed * h.mixed + v.pure * h.pure + v.special * h.special + v.wild * h.wild +
          (c >= 2 ? threes : c === 1 ? 0 : -threes) + (c >= 1 ? v.melded : -v.melded) - v.pen + v.bonus - v.left;
      }
    },
    // Partnership auction pinochle: bid, meld and trick points per hand; the team that took the bid and falls short is set and loses the bid.
    // No melded-cards or left-in-hand lines and no going-out row (plain); the game target is a house value.
    pinochle: {
      key: 'lotus-pinochle-v1', rounds: 0, target: 1500, targetKey: 'game', plain: true,
      house: { game: 1500 }, houseLabels: { game: 'Game to' },
      lines: [
        { k: 'bid', label: 'Bid', step: 10, note: function () { return 'only for the team that took the bid'; } },
        { k: 'meld', label: 'Meld', step: 10, note: function () { return 'points laid down before play'; } },
        { k: 'tricks', label: 'Trick points', step: 10, max: 250, note: function () { return '10 for each ace, ten and king, 10 for the last trick'; } }
      ],
      score: function (v) { var made = v.meld + v.tricks; return v.bid > 0 && made < v.bid ? -v.bid : made; },
      status: function (r, names) {
        var a = num(r.A, 'bid'), b = num(r.B, 'bid'), played = num(r.A, 'tricks') + num(r.B, 'tricks');
        if (!a && !b) return 'enter the bid';
        if (a && b) return 'only one team takes the bid';
        var t = a ? 'A' : 'B', bid = a || b, need = bid - num(r[t], 'meld');
        var s = need > 250 ? names[t] + ' cannot make ' + bid + ', more than 250 short after meld' :
          need <= 0 ? names[t] + ' melded the bid of ' + bid : names[t] + ' bid ' + bid + ', ' + need + ' needed in tricks';
        return played && played !== 250 ? s + '. Trick points add up to ' + played + ', not 250' : s;
      },
      // Both teams at or past the target on the same hand: the team that took the bid on the last hand wins.
      result: function (tA, tB, target, names, rounds) {
        if (tA < target && tB < target) return '';
        var both = tA >= target && tB >= target, w = tA >= target ? 'A' : 'B';
        if (both) { w = ''; for (var i = rounds.length - 1; i >= 0 && !w; i--) w = num(rounds[i].A, 'bid') ? 'A' : num(rounds[i].B, 'bid') ? 'B' : ''; }
        if (!w) return '';
        var hi = (w === 'A' ? tA : tB).toLocaleString(), lo = (w === 'A' ? tB : tA).toLocaleString();
        return both ? 'Both teams reached ' + target.toLocaleString() + '. ' + names[w] + ' took the bid and win, ' + hi + ' to ' + lo + '.' :
          names[w] + ' reached ' + target.toLocaleString() + ': ' + hi + ' to ' + lo + '.';
      }
    }
  };
  var MODES = { classic: 'canasta', ma: 'canastaMA' }, MODE_KEY = 'lotus-canasta-mode';
  var modeBtns = [].slice.call(calc.querySelectorAll('.modes button'));
  var G, LINES, OPEN, st;
  var $ = function (id) { return document.getElementById(id); };
  var body = $('lines');

  function blankRound() { var r = { A: {}, B: {}, out: '', conc: false }; LINES.forEach(function (l) { r.A[l.k] = 0; r.B[l.k] = 0; }); return r; }
  function fresh() { var rounds = []; for (var i = 0; i < (G.rounds || 1); i++) rounds.push(blankRound()); return { names: { A: 'Us', B: 'Them' }, house: Object.assign({}, G.house), rounds: rounds, cur: 0 }; }
  function load() { try { var s = JSON.parse(localStorage.getItem(G.key)); if (s && s.rounds && (OPEN ? s.rounds.length >= 1 : s.rounds.length === G.rounds)) { s.house = Object.assign({}, G.house, s.house); return s; } } catch (e) {} return fresh(); }
  function save() { try { localStorage.setItem(G.key, JSON.stringify(st)); } catch (e) {} }
  function use(name) {
    G = GAMES[name] || GAMES.hf;
    LINES = G.plain ? G.lines : G.lines.concat([
      { k: 'melded', label: 'Melded card points', step: 5, note: function () { return 'add the card values'; }, pts: function (v) { return v; } },
      { k: 'left', label: G.leftLabel, step: 5, note: function () { return 'card values, subtracted'; }, pts: function (v) { return -v; } }
    ]);
    OPEN = !G.rounds; st = load();
    if (st.cur >= st.rounds.length) st.cur = st.rounds.length - 1;
  }

  function roundScore(r, t) {
    var h = st.house, sum = 0;
    if (G.score) { var v = {}; LINES.forEach(function (l) { v[l.k] = num(r[t], l.k); }); sum = G.score(v, h); }
    else LINES.forEach(function (l) { sum += l.pts(num(r[t], l.k), h); });
    if (!G.plain && r.out === t) sum += h.out + (G.concealed && r.conc ? h.concealed : 0);
    return sum;
  }
  function totalBefore(t, n) { var s = 0; for (var i = 0; i < n; i++) s += roundScore(st.rounds[i], t); return s; }
  function renderRounds() {
    if (!OPEN) return;
    var box = calc.querySelector('.rounds'); box.innerHTML = '';
    st.rounds.forEach(function (_, i) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.r = i; b.textContent = i + 1; b.setAttribute('aria-label', 'Hand ' + (i + 1));
      b.addEventListener('click', function () { st.cur = i; render(); });
      box.appendChild(b);
    });
    var add = document.createElement('button'); add.type = 'button'; add.className = 'add'; add.textContent = '+'; add.setAttribute('aria-label', 'Add a hand');
    add.addEventListener('click', function () { st.rounds.push(blankRound()); st.cur = st.rounds.length - 1; render(); calc.querySelector('.rounds button[data-r="' + st.cur + '"]').focus(); });
    box.appendChild(add);
  }
  function render() {
    var r = st.rounds[st.cur], h = st.house;
    renderRounds();
    body.innerHTML = '';
    LINES.forEach(function (l) {
      var tr = document.createElement('tr');
      var th = document.createElement('th'); th.scope = 'row';
      th.innerHTML = l.label + '<small>' + l.note(h) + '</small>';
      tr.appendChild(th);
      ['A', 'B'].forEach(function (t) {
        var td = document.createElement('td');
        var id = 'in-' + l.k + '-' + t;
        td.innerHTML = '<label class="visually-hidden" for="' + id + '">' + l.label + ', ' + st.names[t] + '</label>' +
          '<input type="number" inputmode="numeric" min="0"' + (l.max ? ' max="' + l.max + '"' : '') + ' step="' + (l.step || 1) + '" id="' + id + '" value="' + (r[t][l.k] || '') + '" placeholder="0">';
        td.querySelector('input').addEventListener('input', function (e) { var v = Math.max(0, Number(e.target.value) || 0); r[t][l.k] = l.max ? Math.min(l.max, v) : v; update(); });
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });
    var tr = document.createElement('tr');
    tr.innerHTML = '<th scope="row">Went out<small>' + h.out + ' to the team that goes out</small></th>';
    ['A', 'B'].forEach(function (t) {
      var td = document.createElement('td'); var id = 'out-' + t;
      td.innerHTML = '<label class="visually-hidden" for="' + id + '">' + st.names[t] + ' went out</label><input type="radio" name="out" id="' + id + '"' + (r.out === t ? ' checked' : '') + '>';
      td.querySelector('input').addEventListener('change', function () { r.out = t; update(); });
      tr.appendChild(td);
    });
    if (!G.plain) body.appendChild(tr);
    if (G.concealed) {
      var tc = document.createElement('tr');
      tc.innerHTML = '<th scope="row"><label for="conc">Went out concealed</label><small>' + h.concealed + ' more</small></th><td colspan="2"><input type="checkbox" id="conc"' + (r.conc ? ' checked' : '') + '></td>';
      tc.querySelector('input').addEventListener('change', function (e) { r.conc = e.target.checked; update(); });
      body.appendChild(tc);
    }
    [].forEach.call(calc.querySelectorAll('.rounds button[data-r]'), function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.r) === st.cur)); });
    update();
  }
  function update() {
    var r = st.rounds[st.cur];
    $('rA').textContent = roundScore(r, 'A').toLocaleString();
    $('rB').textContent = roundScore(r, 'B').toLocaleString();
    var tA = totalBefore('A', st.rounds.length), tB = totalBefore('B', st.rounds.length);
    $('tA').textContent = tA.toLocaleString(); $('tB').textContent = tB.toLocaleString();
    $('tAname').textContent = st.names.A + ', total'; $('tBname').textContent = st.names.B + ', total';
    $('tAbox').classList.toggle('lead', tA > tB); $('tBbox').classList.toggle('lead', tB > tA);
    $('rnum').textContent = st.cur + 1;
    if (G.status) {
      $('rmin').textContent = G.status(r, st.names);
      $('result').textContent = G.result(tA, tB, Number(st.house[G.targetKey]) || G.target, st.names, st.rounds);
    } else if (G.need) {
      $('rmin').textContent = st.names.A + ' ' + G.need(totalBefore('A', st.cur)) + ', ' + st.names.B + ' ' + G.need(totalBefore('B', st.cur));
      var res = $('result');
      if (res) res.textContent = (tA >= G.target || tB >= G.target) && tA !== tB ? (tA > tB ? st.names.A : st.names.B) + ' reached ' + G.target.toLocaleString() + ': ' + Math.max(tA, tB).toLocaleString() + ' to ' + Math.min(tA, tB).toLocaleString() + '.' : '';
    } else $('rmin').textContent = G.mins[st.cur];
    save();
  }
  function renderHouse() {
    var g = $('hvals'); g.innerHTML = '';
    Object.keys(G.house).forEach(function (k) {
      var lab = document.createElement('label');
      lab.innerHTML = G.houseLabels[k] + '<input type="number" min="0" step="50" value="' + st.house[k] + '">';
      lab.querySelector('input').addEventListener('change', function (e) { st.house[k] = Math.max(0, Number(e.target.value) || 0); render(); });
      g.appendChild(lab);
    });
  }
  function names() { ['A', 'B'].forEach(function (t) { $('n' + t).value = st.names[t]; }); }
  function sheets(mode) { [].forEach.call(document.querySelectorAll('.print-sheet[data-mode]'), function (s) { s.classList.toggle('off', s.getAttribute('data-mode') !== mode); }); }
  function setMode(mode) {
    use(MODES[mode]); try { localStorage.setItem(MODE_KEY, mode); } catch (e) {}
    modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mode === mode)); });
    sheets(mode); names(); renderHouse(); render();
  }

  var game = calc.getAttribute('data-game') || 'hf', mode = 'classic';
  if (modeBtns.length) { try { mode = localStorage.getItem(MODE_KEY) === 'ma' ? 'ma' : 'classic'; } catch (e) {} game = MODES[mode]; }
  use(game);
  if (!OPEN) [].forEach.call(calc.querySelectorAll('.rounds button'), function (b) {
    b.addEventListener('click', function () { st.cur = Number(b.dataset.r); render(); });
  });
  ['A', 'B'].forEach(function (t) {
    var inp = $('n' + t);
    inp.addEventListener('input', function () { st.names[t] = inp.value.trim() || (t === 'A' ? 'Us' : 'Them'); update(); });
  });
  var armed = false, resetBtn = $('reset');
  resetBtn.addEventListener('click', function () {
    if (!armed) { armed = true; resetBtn.textContent = 'Tap again to clear'; setTimeout(function () { armed = false; resetBtn.textContent = 'New game'; }, 3000); return; }
    var keepHouse = st.house; st = fresh(); st.house = keepHouse; armed = false; resetBtn.textContent = 'New game';
    names(); render();
  });
  $('print').addEventListener('click', function () { window.print(); });
  [].forEach.call(document.querySelectorAll('.print-sheet'), function (s) { document.body.appendChild(s); });
  modeBtns.forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });
  if (modeBtns.length) setMode(mode); else { names(); renderHouse(); render(); }
})();
